function User() {
  return (
    <div>
      <h1>User</h1>
    </div>
  );
}

export default User;
